import type { DbHeygenVoice } from '@/api/astraea';
import { groupVoicesByGender } from '@/lib/voiceGroups';

interface HeygenVoiceSelectProps {
  voices: DbHeygenVoice[];
  value: string;
  onChange: (voiceId: string) => void;
  className?: string;
  allowAuto?: boolean;
  autoLabel?: string;
}

function label(v: DbHeygenVoice) {
  const name = (v.name || v.voice_id).trim();
  return name;
}

/** HeyGen 影片声音 — 按女声/男声分组 */
export default function HeygenVoiceSelect({ voices, value, onChange, className, allowAuto, autoLabel = '自动挑中文声(预设)' }: HeygenVoiceSelectProps) {
  const { female, male, other } = groupVoicesByGender(voices);
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={className}>
      {allowAuto && <option value="">{autoLabel}</option>}
      {female.length > 0 && (
        <optgroup label={`女声 (${female.length})`}>
          {female.map((v) => <option key={v.voice_id} value={v.voice_id}>{label(v)}</option>)}
        </optgroup>
      )}
      {male.length > 0 && (
        <optgroup label={`男声 (${male.length})`}>
          {male.map((v) => <option key={v.voice_id} value={v.voice_id}>{label(v)}</option>)}
        </optgroup>
      )}
      {other.length > 0 && (
        <optgroup label={`其他 (${other.length})`}>
          {other.map((v) => <option key={v.voice_id} value={v.voice_id}>{label(v)}</option>)}
        </optgroup>
      )}
    </select>
  );
}
